<template>
	<div class="uploadPayVoucherContainer">
		<div class="content-wrapper">
			<!-- 左侧内容：付款信息 -->
			<div class="left-content">
				<!-- 收款账户信息 -->
				<div class="bank-info">
					<div class="bank-header">
						<!-- <div class="bank-logo">
							<img src="@/assets/vip/HKB.png" alt="汉口银行" class="logo-image" />
						</div> -->
						<h3 class="bank-title">收款账户信息</h3>
					</div>
					<div class="account-info">
						<div class="info-item">
							<span class="label">开户名称：</span>
							<span class="value">武汉佳软信息技术有限公司</span>
							<el-button type="text" class="copy-btn" @click="copyText('武汉佳软信息技术有限公司')">
								<i class="el-icon-document-copy"></i>
								复制
							</el-button>
						</div>
						<div class="info-item">
							<span class="label">开户银行：</span>
							<span class="value">招商银行光谷科技支行</span>
							<el-button type="text" class="copy-btn" @click="copyText('招商银行光谷科技支行')">
								<i class="el-icon-document-copy"></i>
								复制
							</el-button>
						</div>
						<div class="info-item">
							<span class="label">账&emsp;&emsp;号：</span>
							<span class="value">1279 1903 9210 701</span>
							<el-button type="text" class="copy-btn" @click="copyText('1279 1903 9210 701')">
								<i class="el-icon-document-copy"></i>
								复制
							</el-button>
						</div>
						<div class="info-item">
							<span class="label">订单编号：</span>
							<span class="value">{{ orderNumber }}</span>
							<el-button type="text" class="copy-btn" @click="copyText(orderNumber)">
								<i class="el-icon-document-copy"></i>
								复制
							</el-button>
						</div>
					</div>
					<div class="payment-tips">
						<i class="el-icon-warning-outline"></i>
						<span>请务必确认转账金额准确无误，并在转账备注中注明订单号</span>
					</div>
				</div>

				<!-- 售后服务电话 -->
				<div class="customer-service">
					<div class="service-container">
						<div class="service-item">
							<div class="service-icon">
								<i class="el-icon-service"></i>
							</div>
							<div class="service-info">
								<div class="service-title">售后服务电话</div>
								<div class="service-phone">400-992-5998</div>
							</div>
						</div>
						<div class="service-divider"></div>
						<div class="service-item">
							<div class="service-icon online">
								<i class="el-icon-chat-dot-round"></i>
							</div>
							<div class="service-info">
								<div class="service-title">在线客服</div>
								<div class="service-phone" @click="openQQService">立即咨询</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 右侧内容：付款流程和上传区域 -->
			<div class="right-content">
				<!-- 付款流程指引 -->
				<div class="payment-process">
					<h3 class="process-title">付款流程</h3>
					<div class="process-steps">
						<div class="step">
							<div class="step-icon">
								<i class="el-icon-document-checked"></i>
							</div>
							<div class="step-desc">确认订单</div>
						</div>
						<div class="step-arrow"><i class="el-icon-arrow-right"></i></div>
						<div class="step">
							<div class="step-icon">
								<i class="el-icon-money"></i>
							</div>
							<div class="step-desc">银行转账</div>
						</div>
						<div class="step-arrow"><i class="el-icon-arrow-right"></i></div>
						<div class="step">
							<div class="step-icon">
								<i class="el-icon-upload"></i>
							</div>
							<div class="step-desc">上传凭证</div>
						</div>
						<div class="step-arrow"><i class="el-icon-arrow-right"></i></div>
						<div class="step">
							<div class="step-icon">
								<i class="el-icon-check"></i>
							</div>
							<div class="step-desc">等待确认</div>
						</div>
					</div>
				</div>

				<!-- 上传区域 -->
				<div class="form-content">
					<div class="upload-section">
						<div class="upload-area">
							<h3 class="upload-title">上传付款凭证</h3>
							<el-form ref="payVoucherForm" :model="payVoucherForm" :rules="rules" label-width="0">
								<el-form-item prop="" class="form-item">
									<div v-for="(item, index) in upLoadFile" :key="index" class="preview-images">
										<el-image :src="item" fit="fill" />
										<div class="mask">
											<div class="actions">
												<span title="预览" @click="preview(index)">
													<i class="el-icon-zoom-in" />
												</span>
												<span title="移除" @click="remove(index)">
													<i class="el-icon-delete" />
												</span>
											</div>
										</div>
									</div>
									<el-upload
										v-show="!upLoadFile.length"
										ref="uploadImages"
										:action="uploadParams.action"
										:name="uploadParams.fileName"
										:limit="uploadParams.limit"
										:show-file-list="false"
										:accept="uploadParams.accept.join(',')"
										:on-exceed="onExceed"
										:before-upload="handleBeforeUpload"
										:http-request="fileToBase64Async"
										class="avatar-uploader"
									>
										<div class="images-slot">
											<i class="el-icon-plus avatar-uploader-icon"></i>
											<div class="upload-text">点击上传</div>
										</div>
										<div slot="tip" class="upload-tips">上传转账截图，支持JPG、PNG格式</div>
									</el-upload>
								</el-form-item>
								<div class="form-button-group">
									<el-button type="default" class="form-button form-button--default" @click="handleCancel">
										取消
									</el-button>
									<el-button
										:loading="submitLoading"
										type="primary"
										class="form-button form-button--primary"
										@click="handleSubmitPayVoucher"
									>
										提交
									</el-button>
								</div>
							</el-form>
						</div>

						<div class="voucher-demo">
							<h3 class="demo-title">付款凭证样例</h3>
							<div class="demo-image-container" @click="openDemoImage">
								<img src="@/assets/vip/voucherDemo.png" alt="付款凭证样例" class="demo-image" />
								<div class="demo-image-mask">
									<i class="el-icon-zoom-in"></i>
									<span>点击查看大图</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getToken } from '@/utils/auth'
	import { uploadPaymentVoucher } from '@/api/memberBenefit/index'
	import QQService from '@/mixins/QQService'

	// 上传打款证明
	export default {
		name: 'UploadPayVoucher',
		components: {},
		mixins: [QQService],
		props: {
			// 订单id
			orderId: {
				type: String,
				default: ''
			},
			// 订单编号
			orderNumber: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				uploadParams: {
					action: '#',
					fileName: 'file',
					limit: 1,
					size: 20,
					accept: ['.jpg', '.jpeg', '.png'],
					InternetToken: getToken()
				},
				upLoadFile: [],
				submitLoading: false,
				payVoucherForm: {},
				rules: {}
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {
			// 复制文本
			copyText(text) {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功')
			},

			// 打开样例图片
			openDemoImage() {
				// 创建一个新的窗口并打开样例图片
				const demoUrl = require('@/assets/vip/voucherDemo.png')
				window.open(demoUrl, '_blank')
			},

			handleBeforeUpload(file) {
				const fileName = file.name.split('.')
				const fileExt = '.' + fileName[fileName.length - 1]
				const isTypeOk = this.uploadParams.accept.indexOf(fileExt) >= 0
				const isSizeOk = file.size / 1024 / 1024 < this.uploadParams.size
				if (!isTypeOk) {
					this.$message.error(`上传图片只支持 ${this.uploadParams.accept.join(' / ')} 格式！`)
				}
				if (!isSizeOk) {
					this.$message.error(`上传图片大小不能超过 ${this.uploadParams.size}MB！`)
				}
				return isTypeOk && isSizeOk
			},
			// 文件选择超出个数时的回调
			onExceed() {
				this.$modal.msgWarning(`最多选择${this.uploadParams.limit}个文件`)
			},

			// file 转base64
			fileToBase64Async(file) {
				const _this = this

				const reader = new FileReader()
				reader.readAsDataURL(file.file)
				// 开始转
				reader.onload = () => {
					_this.upLoadFile.push(reader.result)
				}
			},

			// 预览
			preview(index) {
				// 将base64转换为Blob
				const base64Data = this.upLoadFile[index]
				// 从base64中提取数据部分（去掉"data:image/jpeg;base64,"这样的前缀）
				const parts = base64Data.split(';base64,')
				const contentType = parts[0].split(':')[1]
				const raw = window.atob(parts[1])
				const rawLength = raw.length
				const uInt8Array = new Uint8Array(rawLength)

				for (let i = 0; i < rawLength; ++i) {
					uInt8Array[i] = raw.charCodeAt(i)
				}

				// 创建Blob对象
				const blob = new Blob([uInt8Array], { type: contentType })
				// 创建临时URL
				const blobUrl = URL.createObjectURL(blob)

				// 在新窗口中打开
				window.open(blobUrl, '_blank')

				// 使用完后释放URL
				setTimeout(() => {
					URL.revokeObjectURL(blobUrl)
				}, 100)
			},

			// 移除
			remove(index) {
				this.upLoadFile.splice(index, 1)
				this.$refs.uploadImages.uploadFiles.splice(index, 1)
			},

			// 提交上传打款凭证
			handleSubmitPayVoucher() {
				if (!this.upLoadFile.length) {
					this.$message.warning('请先上传付款凭证')
					return
				}
				this.submitLoading = true

				// 将base64转换为Blob
				const base64Data = this.upLoadFile[0]
				const parts = base64Data.split(';base64,')
				const contentType = parts[0].split(':')[1]
				const raw = window.atob(parts[1])
				const rawLength = raw.length
				const uInt8Array = new Uint8Array(rawLength)

				for (let i = 0; i < rawLength; ++i) {
					uInt8Array[i] = raw.charCodeAt(i)
				}

				// 创建Blob对象
				const blob = new Blob([uInt8Array], { type: contentType })

				// 创建文件对象
				const fileName = `payment_voucher_${new Date().getTime()}.${contentType.split('/')[1]}`
				const file = new File([blob], fileName, { type: contentType })

				// 创建FormData
				const formData = new FormData()
				formData.append('orderId', this.orderId)
				formData.append('file', file)
				uploadPaymentVoucher(formData)
					.then(response => {
						this.$modal.msgSuccess('上传成功')
						this.submitLoading = false
						this.$emit('uploadSuccess')
					})
					.catch(error => {
						this.submitLoading = false
						this.$message.error(error.message)
					})
			},

			// 取消
			handleCancel() {
				this.$emit('uploadCancel')
			},

			// 打开企点客服
			openQQService() {
				this.handleEvokeQQ()
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/element-reset.scss';

	.uploadPayVoucherContainer {
		padding: 15px;
		background-color: #fff;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		max-height: calc(100vh - 200px);
		overflow: hidden;
	}

	.content-wrapper {
		display: flex;
		gap: 15px;
		height: 100%;
	}

	.left-content {
		width: 45%;
		display: flex;
		flex-direction: column;
	}

	.right-content {
		width: 55%;
		display: flex;
		flex-direction: column;
	}

	/* 付款流程样式 */
	.payment-process {
		margin-bottom: 15px;
		padding: 15px;
		background-color: #f8f9fa;
		border-radius: 8px;
		border: 1px solid #eaeaea;

		.process-title {
			font-size: 16px;
			color: #333;
			margin-bottom: 15px;
			font-weight: bold;
			position: relative;
			padding-left: 10px;

			&:before {
				content: '';
				position: absolute;
				left: 0;
				top: 50%;
				transform: translateY(-50%);
				width: 4px;
				height: 16px;
				background-color: #2671cb;
				border-radius: 2px;
			}
		}

		.process-steps {
			display: flex;
			align-items: center;
			justify-content: space-between;

			.step {
				display: flex;
				flex-direction: column;
				align-items: center;

				.step-icon {
					width: 40px;
					height: 40px;
					line-height: 40px;
					text-align: center;
					background-color: #2671cb;
					color: #fff;
					border-radius: 50%;
					font-weight: bold;
					margin-bottom: 8px;
					font-size: 18px;
					box-shadow: 0 4px 10px rgba(38, 113, 203, 0.3);
				}

				.step-desc {
					font-size: 14px;
					color: #333;
					font-weight: 500;
				}
			}

			.step-arrow {
				font-size: 18px;
				color: #999;
			}
		}
	}

	/* 银行信息样式 */
	.bank-info {
		margin-bottom: 15px;
		padding: 15px;
		background-color: #f0f7ff;
		border-radius: 8px;
		border: 1px solid #d8e7fe;

		.bank-header {
			display: flex;
			align-items: center;
			margin-bottom: 15px;

			.bank-logo {
				margin-right: 15px;

				.logo-image {
					width: 160px;
					height: auto;
					max-height: 50px;
					object-fit: contain;
				}
			}

			.bank-title {
				font-size: 16px;
				color: #333;
				font-weight: bold;
			}
		}

		.account-info {
			background-color: #fff;
			padding: 15px;
			border-radius: 8px;
			margin-bottom: 10px;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

			.info-item {
				display: flex;
				align-items: center;
				margin-bottom: 10px;

				&:last-child {
					margin-bottom: 0;
				}

				.label {
					width: 80px;
					font-weight: bold;
					color: #333;
					font-size: 16px;
				}

				.value {
					flex: 1;
					color: #333;
					font-size: 16px;
					font-family: monospace;
					letter-spacing: 1px;
				}

				.copy-btn {
					color: #2671cb;
					padding: 0 5px;
					font-size: 14px;

					&:hover {
						color: #1c5ca9;
					}
				}
			}
		}

		.payment-tips {
			display: flex;
			align-items: center;
			color: #e6a23c;
			font-size: 14px;
			background-color: #fdf6ec;
			padding: 8px 10px;
			border-radius: 4px;

			i {
				margin-right: 5px;
				font-size: 14px;
			}
		}
	}

	/* 售后服务电话样式 */
	.customer-service {
		margin-bottom: 0;
		padding: 0;
		background-color: transparent;
		border-radius: 8px;

		.service-container {
			display: flex;
			align-items: stretch;
			background-color: #f6f6f6;
			border-radius: 8px;
		}

		.service-item {
			flex: 1;
			display: flex;
			align-items: center;
			padding: 20px;
		}

		.service-divider {
			width: 1px;
			background-color: #ddd;
			margin: 10px 0;
		}

		.service-icon {
			width: 36px;
			height: 36px;
			background-color: #2671cb;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			font-size: 18px;
			margin-right: 10px;

			&.online {
				background-color: #67c23a;
			}
		}

		.service-info {
			.service-title {
				font-size: 14px;
				color: #666;
				margin-bottom: 3px;
			}

			.service-phone {
				font-size: 16px;
				font-weight: bold;
				color: #2671cb;
				margin-bottom: 0;
			}

			.service-desc {
				font-size: 12px;
				color: #999;
			}
		}
	}

	/* 上传表单样式 */
	.form-content {
		background-color: #f8f9fa;
		padding: 15px;
		border-radius: 8px;
		border: 1px solid #eaeaea;
		flex: 1;

		.upload-title {
			font-size: 16px;
			color: #333;
			margin-bottom: 15px;
			font-weight: bold;
			position: relative;
			padding-left: 10px;

			&:before {
				content: '';
				position: absolute;
				left: 0;
				top: 50%;
				transform: translateY(-50%);
				width: 4px;
				height: 16px;
				background-color: #2671cb;
				border-radius: 2px;
			}
		}
	}

	.upload-section {
		display: flex;
		gap: 20px;
	}

	.upload-area {
		flex: 1;
	}

	.voucher-demo {
		width: 200px;
	}

	.demo-title {
		font-size: 16px;
		color: #333;
		margin-bottom: 15px;
		font-weight: bold;
		position: relative;
		padding-left: 10px;

		&:before {
			content: '';
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 4px;
			height: 16px;
			background-color: #2671cb;
			border-radius: 2px;
		}
	}

	.demo-image-container {
		position: relative;
		cursor: pointer;
		border-radius: 6px;
		overflow: hidden;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
	}

	.demo-image {
		width: 100%;
		height: auto;
		display: block;
	}

	.demo-image-mask {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: white;
		opacity: 0;
		transition: opacity 0.3s;

		i {
			font-size: 24px;
			margin-bottom: 5px;
		}

		span {
			font-size: 14px;
		}
	}

	.demo-image-container:hover .demo-image-mask {
		opacity: 1;
	}

	.preview-images {
		position: relative;
		display: inline-block;
		border-radius: 6px;
		overflow: hidden;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

		.el-image {
			display: block;
			width: 140px;
			height: 140px;
		}

		.mask {
			opacity: 0;
			position: absolute;
			top: 0;
			width: 100%;
			height: 100%;
			font-size: 20px;
			background-color: rgba(0, 0, 0, 0.5);
			transition: all 0.3s;

			.actions {
				width: 80px;
				height: 80px;
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				justify-content: center;
				@include position-center(xy);

				span {
					width: 50%;
					text-align: center;
					color: #fff;
					cursor: pointer;
					transition: all 0.1s;

					&.disabled {
						color: #999;
						cursor: not-allowed;
					}

					&:hover:not(.disabled) {
						transform: scale(1.5);
					}
				}
			}
		}

		&:hover .mask {
			opacity: 1;
		}
	}

	.avatar-uploader {
		::v-deep .el-upload {
			width: 140px;
			height: 140px;
			border: 2px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
			background-color: #fafafa;
			transition: all 0.3s;

			&:hover {
				border-color: #409eff;
				background-color: #f5f7fa;
			}

			.avatar-uploader-icon {
				font-size: 24px;
				color: #8c939d;
				width: 140px;
				height: 100px;
				line-height: 100px;
				text-align: center;
			}

			.upload-text {
				text-align: center;
				color: #606266;
				font-size: 14px;
			}
		}

		.upload-tips {
			margin-top: 8px;
			color: #909399;
			font-size: 14px;
		}
	}

	.form-button-group {
		margin-top: 15px;
		text-align: center;

		.form-button {
			min-width: 100px;
			margin: 0 8px;
			border-radius: 4px;
			padding: 8px 15px;

			&--primary {
				background-color: #2671cb;
				border-color: #2671cb;

				&:hover {
					background-color: #1c5ca9;
					border-color: #1c5ca9;
				}
			}
		}
	}
</style>
